import { createContext, useContext } from "react";
import { Event } from "../../models/Event";

const EventsContext = createContext<EventsContextType>({
  events: [],
  setEvents: () => {},
  selectedEvent: {
    id: 0,
    title: "",
    cover_image: "",
    lat: 0,
    lng: 0,
    start_date: "",
    end_date: "",
  },
  setSelectedEvent: () => {},

  handleSelectEvent: async () => {},
  handleRemoveEvent: () => {},
  isLoading: false,
  hasSelectedEvent: false,
  isSwitchingEvent: false,
  refetchEvents: () => {},
  getEventCoordinates: () => ({ lat: 0, lng: 0 }),
  eventCoordinates: {
    lat: 0,
    lng: 0,
    address: "",
  },
  getEvent: () => undefined,
});

export type EventsContextType = {
  events: Event[];
  setEvents: React.Dispatch<React.SetStateAction<Event[]>>;
  selectedEvent: Event | null;
  setSelectedEvent: React.Dispatch<React.SetStateAction<Event | null>>;
  handleSelectEvent: (event: Event) => Promise<void>;
  handleRemoveEvent: (route?: string) => void;
  isLoading: boolean;
  hasSelectedEvent: boolean;
  isSwitchingEvent: boolean;
  refetchEvents: () => void;
  getEventCoordinates: () => EventsContextType["eventCoordinates"];
  eventCoordinates:
    | { lat: number; lng: number }
    | { lat: number; lng: number; address: string };
  getEvent: (eventId: string) => Event | undefined;
};

export const usePrimaryEvents = () => useContext(EventsContext);
export default EventsContext;
